/**
 * MoMent — les calculs de la DATE DE DÉBUT DE GROSSESSE (DDG), pour l'écran du chargement
 * (RQ, 11/10/2026). DDG = date de conception = date de référence − (terme à cette date − 14 j).
 * Robinson est une COPIE du moteur (`termeRobinson`), vérifiée par un test miroir.
 * Module pur : rien n'est écrit, c'est un outil de lecture.
 */

const JOUR = 86400000;
const t = (iso: string): number => Date.parse(`${iso.slice(0, 10)}T12:00:00Z`);
const iso = (ms: number): string => new Date(ms).toISOString().slice(0, 10);
const plus = (d: string, jours: number): string => iso(t(d) + jours * JOUR);

/** Robinson (1975) : terme en jours depuis la DDR, LCC en mm. Copie du moteur (`termeRobinson`). */
/* Robinson & Fleming (1975) AVEC le facteur 1,037 (correction de la vitesse des ultrasons),
   comme SsdwLab : vérifié le 12/10/2026 sur 4 LCC imprimées (47,9→80 j, 53→83, 58,5→86, 82→98).
   Sans ce facteur, le terme sortait de 1 à 2 jours trop court. */
export const termeRobinson = (lccMm: number): number => Math.round(8.052 * Math.sqrt(lccMm * 1.037) + 23.73);

export const termeLisible = (j: number): string => `${Math.floor(j / 7)} SA + ${j % 7} j`;

/** La DDG quand on connaît le terme (jours depuis la DDR) à une date donnée. */
export const ddgDepuisTerme = (date: string, termeJours: number): string => plus(date, -(termeJours - 14));
